export const ELEVATED = ['company_admin', 'developer', 'manager'];
export const LABEL_MANAGERS = ['company_admin', 'developer', 'manager'];
export const AGENT_LIKE = ['agent', 'trainee'];
export const KANBAN_ROLES = ['company_admin', 'developer', 'manager'];

export function canEditTicket(role, uid, ticket) {
  if (!ticket || !uid) return false;
  if (role === 'super_admin') return true;
  if (ELEVATED.includes(role)) return true;
  if (AGENT_LIKE.includes(role)) {
    return ticket.reporterUid === uid || ticket.assigneeUid === uid;
  }
  return false;
}

export function canDeleteTicket(role, uid, ticket) {
  if (!ticket || !uid) return false;
  if (role === 'super_admin') return true;
  if (ELEVATED.includes(role)) return true;
  if (AGENT_LIKE.includes(role)) return ticket.reporterUid === uid;
  return false;
}

/** Firestore returns this while a composite index is still provisioning. */
export function firestoreIndexStillBuilding(err) {
  const msg = String(err?.message || '');
  return /currently building|cannot be used yet|still building/i.test(msg);
}

export function firestoreIndexUrlFromError(err) {
  const msg = String(err?.message || '');
  const m = msg.match(/https:\/\/console\.firebase\.google\.com[^\s)'"]+/);
  return m ? m[0] : null;
}
